import * as React from 'react'
import type { ImageProps } from './Image.types'
import { cn } from '@core/utils'

const Image: React.FC<ImageProps> = ({ src, className, ...props }) => {
    const [loaded, setLoaded] = React.useState<boolean>(false)

    React.useEffect(() => {
        setLoaded(false)
    }, [src])

    return (
        <img
            data-state={loaded ? 'loaded' : undefined}
            src={src}
            onLoad={() => setLoaded(true)}
            className={cn(
                'opacity-0 transition-all duration-300',
                'data-[state=loaded]:opacity-100',
                className,
            )}
            {...props}
        />
    )
}

export default Image
